import { useOutlet } from 'react-router-dom';

export const PlainLayout = () => {
  const outlet = useOutlet();

  return (
    <div style={{ width: '100%', minHeight: '100vh' }}>
      {outlet}
    </div>
  );
}; 